import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';

import { IBitfLoaderAction, IBitfLoaderComponent } from '@interfaces';
import { EBitfLoaderAction } from '@enums';
import { LoaderService } from '@services';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'bitf-loader',
  templateUrl: './bitf-loader.component.html',
  styleUrls: ['./bitf-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BitfLoaderComponent implements OnInit, IBitfLoaderComponent {
  canShowLoader = false;
  loaderData: any;
  private readonly cdr = inject(ChangeDetectorRef);

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.onLoaderChange.subscribe((loaderAction: IBitfLoaderAction) => {
      switch (loaderAction.action) {
        case EBitfLoaderAction.SHOW:
          this.loaderData = loaderAction.data;
          this.show();
          this.loaderService.isLoading = true;
          break;
        case EBitfLoaderAction.HIDE:
          this.loaderData = undefined;
          this.hide();
          this.loaderService.isLoading = false;
          break;
      }
    });
  }

  show() {
    setTimeout(() => {
      this.canShowLoader = true;
      this.cdr.markForCheck();
    });
  }

  hide() {
    setTimeout(() => {
      this.canShowLoader = false;
      this.cdr.markForCheck();
    });
  }
}
